// User Menu Configuration
// 0 = ไม่สามารถเข้าถึงได้, 1 = สามารถเข้าถึงได้

const USER_MENU_CONFIG = {
  // Admin Users - เข้าถึงได้ทุกเมนู
  'somporn': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    technicianMap: 1,
    changePassword: 1
  },
  'saritwat': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    technicianMap: 1,
    corpErp: 1,
    changePassword: 1
  },
   'pensri': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
  'maneenuch': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
   'prapaiporn': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 0,
    salesTeam: 0,
    changePassword: 1
  },
  'pornchai': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
  'suporn': {
    dashboard: 1,
    invoiceReport: 1,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
  'pattanawit': {
    dashboard: 1,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
  'sudsawat': {
    dashboard: 1,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },

  'narongrit': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
  'chaivichit': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
   'atiwat': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },
   'anchalee': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 1,
    customerSummary: 1,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 1,
    changePassword: 1
  },

  //Factory
   'amnauy': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 0,
    changePassword: 1
  },
   'somboon': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 0,
    changePassword: 1
  },
   'hong': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 1,
    productDetails: 1,
    productSalesTeam: 1,
    salesTeam: 0,
    changePassword: 1
  },
  'supaporn_vat': {
    dashboard: 0,
    invoiceReport: 1,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 0,
    productDetails: 0,
    salesTeam: 0,
    changePassword: 1
  },
  'wasana_acc': {
    dashboard: 0,
    invoiceReport: 1,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 0,
    productDetails: 0,
    salesTeam: 0,
    changePassword: 1
  },
  'anutsara_aus': {
    dashboard: 0,
    invoiceReport: 1,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 0,
    productDetails: 0,
    salesTeam: 0,
    changePassword: 1
  },
  'kantima': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 0,
    productDetails: 0,
    productSalesTeam: 0,
    salesTeam: 1,
    technicianMap: 0,
    changePassword: 1
  },

  // Limited Users - เข้าถึงได้เฉพาะเมนูพื้นฐาน
  'default': {
    dashboard: 0,
    invoiceReport: 0,
    salesOverview: 0,
    customerSummary: 0,
    topProducts: 0,
    productDetails: 0,
    salesTeam: 0,
    technicianMap: 0,
    changePassword: 1
  }
};

// ฟังก์ชันสำหรับตรวจสอบสิทธิ์การเข้าถึงเมนู
export const getUserMenuAccess = (username) => {
  if (!username) return USER_MENU_CONFIG['default'];
  
  const userKey = username.toLowerCase();
  return USER_MENU_CONFIG[userKey] || USER_MENU_CONFIG['default'];
};

// ฟังก์ชันสำหรับตรวจสอบสิทธิ์เมนูเฉพาะ
export const hasMenuAccess = (username, menuId) => {
  const userAccess = getUserMenuAccess(username);
  return userAccess[menuId] === 1;
};

// ฟังก์ชันสำหรับตรวจสอบว่าเป็น admin user หรือไม่
export const isAdminUser = (username) => {
  if (!username) return false;
  
  const adminUsers = ['somporn', 'saritwat', 'maneenuch', 'suporn', 'pornchai', 'sudsawat'];
  return adminUsers.includes(username.toLowerCase());
};

export default USER_MENU_CONFIG;